import { Button, Space } from 'antd'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'

const NumeralButton = props => {
const {changeValue, changeValueDecimal, callBack, objName, lblName, initValue, disabled} = props
const [counter, setCounter] = useState(initValue)

useEffect(() => {
    callBack({target:{name:`${objName}`, value:counter, attributes:{type:'number'}}})
}, [counter])

const handleIncrement = () => {
    setCounter(Number((counter + changeValue).toFixed(1)))
}

const handleIncrementDecimal = () => {
    setCounter(Number((counter + changeValueDecimal).toFixed(1)))
}

const handleDecrementDecimal = () => {
    if (counter - changeValueDecimal < 0) { setCounter(0); return }
    setCounter(Number((counter - changeValueDecimal).toFixed(1)))
}

const handleDecrement = () => {
    if (counter - changeValue < 0) { setCounter(0); return }
    setCounter(Number((counter - changeValue).toFixed(1)))
}

return (
    <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
        {lblName}
        <Space.Compact size="small">
            {changeValueDecimal > 0 && counter > 0 && (
                <Button disabled={disabled} onClick={handleIncrementDecimal} icon={<PlusOutlined />} />
            )}
            {changeValueDecimal > 0 && counter > 0 && (
                <Button disabled={disabled} onClick={handleDecrementDecimal} icon={<MinusOutlined />} />
            )}
            {counter > 0 && (
                <Button disabled type="primary" style={{minWidth: 36, cursor:'default', opacity:1}}>
                    {counter}
                </Button>
            )}
            <Button disabled={disabled} onClick={handleIncrement} icon={<PlusOutlined />} />
            {counter > 0 && (
                <Button disabled={disabled} onClick={handleDecrement} icon={<MinusOutlined />} />
            )}
        </Space.Compact>
    </div>
)
}

export default NumeralButton